exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".label-width{width:25%;min-width:250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2d089a60!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/editClass.vue
// module id = 483
// module chunks = 0